import { action, observable } from 'mobx'
import { InfoOptionRequest } from '../requests/InfoOptionRequest'

class InfoOptionStore {
  @observable infoOptions = new Map()

  @action load = async id => {
    if (!this.infoOptions.get(id)) {
      const link = await InfoOptionRequest.get(id)
        .then(response => {
          let link = response.data?.value
          return link
        })
        .catch(() => {
          return ''
        })
      if (link) {
        this.setInfoOptions(id, link)
      }
      return link
    } else {
      return this.infoOptions.get(id)
    }
  }

  @action setInfoOptions = (id, link) => {
    this.infoOptions.set(id, link)
  }
}

export default new InfoOptionStore()
